import {
  formatDateToString,
  globalDob,
  globalExpiryDate,
} from '../../src/mock/dictionaries/dates';
import {
  AdditionalInformationRegulatory,
  CountryInformation,
  DestinationAddress,
  EmergencyContactRegulatory,
  GreenCardDocumentRegulatory,
  Nationality,
  PersonalDetailsRegulatory,
  PersonalTravelDocumentRegulatory,
  SecurityInformationRegulatory,
} from '../models/index';

// Pre-compute formatted dates for optimization
const formattedDob = formatDateToString(globalDob);
const formattedExpiryDate = formatDateToString(globalExpiryDate);

const personalTravelDocument: Record<string, PersonalTravelDocumentRegulatory> = {
  validPersonalTravelDocumentRegulatory: {
    travelDocumentIndex: 0,
    documentNumber: '5555555555554444',
    country: 'Spain',
    DocumentIssuingCountry: 'Spain',
    expiryDate: formattedExpiryDate
  },
  validPersonalTravelDocumentUSReg: {
    travelDocumentIndex: 0,
    documentNumber: '1111222233334444',
    country: 'India',
    DocumentIssuingCountry: 'India',
    expiryDate: formattedExpiryDate
  }
};

const nationality: Record<string, Nationality> = {
  validNationality: {
    nationality: 'French'
  },
  validNationalityUSReg: {
    nationality: 'Indian'
  }
};

const countryInformation: Record<string, CountryInformation> = {
  validCountryInformation: {
    countryInformation: 'France'
  },
  validCountryInformationUSReg: {
    countryInformation: 'United States'
  }
};

const personalDetails: Record<string, PersonalDetailsRegulatory> = {
  validPersonalDetailsMaleUSReg: {
    genderIndex: 1,
    birthDate: formattedDob
  },
  validPersonalDetailsUnspecifiedUSReg: {
    genderIndex: 2,
    birthDate: formattedDob
  },
  validPersonalDetailsMaleUSRegMock: {
    genderIndex: 1,
    birthDate: formattedDob
  },
  validPersonalDetailsUnspecifiedUSRegMock: {
    genderIndex: 2,
    birthDate: formattedDob
  }
};

const entryDocument: Record<string, GreenCardDocumentRegulatory> = {
  validPermanentResidentCardUSReg: {
    entryDocumentIndex: 1,
    documentNumber: 'PRC11223344',
    country: 'India',
    documentIssuingCountry: 'United States',
    documentExpiryDate: formattedExpiryDate
  },
  validResidentAlienCardUSReg: {
    entryDocumentIndex: 0,
    documentNumber: 'RAL11223344',
    country: 'India',
    documentIssuingCountry: 'United States',
    documentExpiryDate: formattedExpiryDate
  }
};

const destinationAddress: Record<string, DestinationAddress> = {
  validDestinationAddress: {
    address: 'abcd',
    postCode: '06700',
    city: 'Nice',
    country: 'France'
  },
  validDestinationAddressUSReg: {
    address: 'address 1',
    postCode: '06700',
    city: 'Montgomery',
    country: 'United States',
    state: 'US_AL',
    stateIndex: 1
  }
};

const emergencyContact: Record<string, EmergencyContactRegulatory> = {
  validEmergencyContactUSReg: {
    name: 'Emer Gency',
    phoneCountryCode: '+33',
    number: '744444489',
    country: 'United States'
  }
};

const securityInformation: Record<string, SecurityInformationRegulatory> = {
  validSecurityInformationUSReg: {
    redressNumber: '1234567',
    knownTravelerNumber: '123456789',
    countryCode: 'USA'
  }
};

const additionalInformation: Record<string, AdditionalInformationRegulatory> = {
  validAdditionalInformationUSReg: {
    purposeOfVisit: 'work',
    purposeOfVisitIndex: 4
  }
};

export const validAdditionalInformationUSReg = additionalInformation.validAdditionalInformationUSReg;
export const validCountryInformation = countryInformation.validCountryInformation;
export const validCountryInformationUSReg = countryInformation.validCountryInformationUSReg;
export const validDestinationAddress = destinationAddress.validDestinationAddress;
export const validDestinationAddressUSReg = destinationAddress.validDestinationAddressUSReg;
export const validEmergencyContactUSReg = emergencyContact.validEmergencyContactUSReg;
export const validNationality = nationality.validNationality;
export const validNationalityUSReg = nationality.validNationalityUSReg;
export const validPersonalDetailsMaleUSReg = personalDetails.validPersonalDetailsMaleUSReg;
export const validPersonalDetailsUnspecifiedUSReg = personalDetails.validPersonalDetailsUnspecifiedUSReg;
export const validPersonalDetailsMaleUSRegMock = personalDetails.validPersonalDetailsMaleUSRegMock;
export const validPersonalDetailsUnspecifiedUSRegMock = personalDetails.validPersonalDetailsUnspecifiedUSRegMock;
export const validPersonalTravelDocumentRegulatory = personalTravelDocument.validPersonalTravelDocumentRegulatory;
export const validPersonalTravelDocumentUSReg = personalTravelDocument.validPersonalTravelDocumentUSReg;
export const validPermanentResidentCardUSReg = entryDocument.validPermanentResidentCardUSReg;
export const validResidentAlienCardUSReg = entryDocument.validResidentAlienCardUSReg;
export const validSecurityInformationUSReg = securityInformation.validSecurityInformationUSReg;
